import { format } from "date-fns-tz";

export const capitalize = (input: string) => {
  let buffer = "";

  for (let i = 0; i < input.length; i++) {
    /* always uppercase on the first character */
    if (i === 0) {
      buffer += input[i].toUpperCase();
      continue;
    }

    if (
      i + 1 !== input.length &&
      input[i].toUpperCase() === input[i] &&
      input[i] !== " "
    ) {
      buffer += ` ${input[i]}`;
      continue;
    }

    if (input[i - 1] === " ") {
      buffer += input[i].toUpperCase();
      continue;
    }

    buffer += input[i];
  }

  return buffer;
};

export const formatYYMMDD = (date: string | number) =>
  format(new Date(date), "yyyy-MM-dd");

export const formatYYMMDDandTime = (date: string | number) => {
  return format(new Date(date), "yyyy-MM-dd hh:mm aa");
};

export const formatTimeAndYYMMDD = (date: string | number) => {
  return format(new Date(date), "hh:mm aa yyyy-MM-dd");
};

export const formatWGS84 = (
  coordinates: [number, number] | { latitude: number; longitude: number }
) => {
  if (coordinates === null) return null;

  if (Array.isArray(coordinates)) {
    coordinates = {
      latitude: coordinates[1],
      longitude: coordinates[0],
    };
  }

  return {
    latitude: `${Number(coordinates.latitude).toFixed(5)}° ${
      coordinates.latitude < 0 ? "S" : "N"
    }`,
    longitude: `${Number(coordinates.longitude).toFixed(5)}° ${
      coordinates.longitude > 0 ? "W" : "E"
    }`,
  };
};

export const formatBytes = (bytes: number) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1000;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${(bytes / Math.pow(k, i)).toFixed(2).padEnd(1, "0")} ${sizes[i]}`;
};

/** Whole hours from a duration in seconds, rounded (order-type deadline UI). */
export const roundedHoursFromSeconds = (seconds: number): number =>
  Math.round(seconds / 3600);

export const formatDuration = (seconds: number) => {
  if (!isFinite(seconds) || seconds <= 0) {
    return "-";
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (hours === 0 && minutes === 0) {
    return "Less than a minute remaining";
  }

  if (hours === 0) {
    return `${minutes} ${minutes === 1 ? "minute" : "minutes"} remaining`;
  }

  if (minutes === 0) {
    return `${hours} ${hours === 1 ? "hour" : "hours"} remaining`;
  }

  return `${hours} ${hours === 1 ? "hour" : "hours"} and ${minutes} ${
    minutes === 1 ? "minute" : "minutes"
  } remaining`;
};

export const formatTimeOnly = (date: Date | number) => {
  return format(date, "h:mm aa");
};

export const formatCountdown = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes > 0) {
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  }
  return `${seconds}s`;
};
